import ResCard from './ResCard';

export default ResCard;
